import Vue from 'vue'

Vue.filter('toDate', function (value, format = 'L', addMinute = 0) {
    if (!value) return ''
    if (typeof value !== 'string') return 'String value only!'
    value = Vue.prototype.$generalizeDate(value)
    return Vue.prototype.$date(value).add(addMinute, 'm').format(format)
})
